import React from "react";
import { createRoot } from "react-dom/client";
import { SpotLeaf } from "design_system/Icon";

(() => {
    "use strict";
    $("#link_id").mask("0000-0000-0000");
    $("._dob-l10n").mask("00/00/0000");

    const container = $("#icon-placeholder").get(0) as HTMLElement;
    if (container) {
        const root = createRoot(container);
        root.render(<SpotLeaf strokeWidth="1" spotColor="#C9DBFE" aria-hidden="true" />);
    }

    const linkIdErrorId = "link_id_error";
    const dobErrorId = "dob_error";

    const linkIdInput = document.getElementById("link_id");
    const dobInput = document.getElementById("dob");
    const linkIdError = document.getElementById(linkIdErrorId);
    const dobError = document.getElementById(dobErrorId);

    if (linkIdError) {
        if (linkIdInput) {
            linkIdInput.focus();
        }
    } else if (dobError) {
        if (dobInput) {
            dobInput.focus();
        }
    } else {
        const formLevelErrors = document.getElementById("form-level-errors");
        if (formLevelErrors) {
            formLevelErrors.setAttribute("tabindex", "-1");
            formLevelErrors.focus();
        }
    }
})();

export {};
